import React from 'react';
import {PlanGetSchema} from '../../../../api/DBSchema/Plan';
import BaseTimezone from '../../AbstractObjects/GatewayPlan/InnerPages/BaseTimezone';

const pageSchema = PlanGetSchema.pages.timezone;
const pageId = pageSchema.pageId;

function PlanTimezone({
    planObject,
    setPlanData,
}) {

    let pageData = planObject[pageId];

    return (
        <BaseTimezone
            pageData={pageData}
            setObjectData={setPlanData}
        />
    );
}

export default PlanTimezone;